export default "__VITE_ASSET__Dap3DvPw__"